import React, { useState } from 'react';
import { RotateCcw, Quote } from 'lucide-react';
import { cn } from '../lib/utils';

export const FlipTile = ({ icon: Icon, title, text, back, index = 0, testId }) => {
  const [flipped, setFlipped] = useState(false);
  const toggle = () => setFlipped((f) => !f);
  return (
    <div className="flip-scene tile-reveal h-full" style={{ animationDelay: `${index * 60}ms` }}>
      <div
        role="button"
        tabIndex={0}
        aria-pressed={flipped}
        data-testid={testId}
        onClick={toggle}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } }}
        className={cn('flip-card h-full min-h-[190px] cursor-pointer select-none outline-none focus-visible:ring-2 focus-visible:ring-ink-400 rounded-xl', flipped && 'is-flipped')}
      >
        <div className="flip-face group h-full rounded-xl border border-line bg-white p-5 shadow-card hover:shadow-lift transition-shadow duration-200 flex flex-col">
          <div className="flex items-start justify-between">
            <div className="h-9 w-9 rounded-lg bg-paper-100 border border-line flex items-center justify-center text-ink-600 group-hover:bg-ink-700 group-hover:text-white group-hover:border-ink-700 transition-colors"><Icon className="h-4 w-4" /></div>
            <RotateCcw className="h-3.5 w-3.5 text-ink-300 group-hover:text-ink-500 transition-colors" />
          </div>
          <div className="mt-4 font-semibold text-ink-800">{title}</div>
          <p className="mt-1.5 text-sm text-ink-500 leading-relaxed">{text}</p>
        </div>
        <div className="flip-face flip-back rounded-xl border border-ink-700 bg-ink-700 text-paper-50 p-5 shadow-lift flex flex-col">
          <div className="flex items-start justify-between">
            <Quote className="h-4 w-4 text-ink-300" />
            <span className="text-[10px] uppercase tracking-[0.14em] text-ink-300 font-semibold">{title}</span>
          </div>
          <p className="mt-4 text-[15px] leading-relaxed font-medium flex-1" data-testid={testId ? `${testId}-back` : undefined}>{back}</p>
          <div className="mt-3 text-[11px] text-ink-300 flex items-center gap-1.5"><RotateCcw className="h-3 w-3" />Tap to flip back</div>
        </div>
      </div>
    </div>
  );
};
